import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import {type AxiosResponse} from 'axios';
import {type ApplicationContextInterface} from "@@/package/application/applicationContext";
import {AssessmentResultListModel} from "~~/package/mapper/assessment/model/AssessmentResultListModel";
import AssessmentApi from "~~/package/apis/assessment/AssessmentApi";
import {AssessmentHelper} from "~~/package/mapper/assessment/AssessmentHelper";
import {AssessmentResultDetailModel} from "~~/package/mapper/assessment/model/AssessmentResultDetailModel";
import {AssessmentAvailableCountModel} from "~~/package/mapper/assessment/model/AssessmentAvailableCountModel";
import type TaskCompleteRequest from "~~/package/apis/learning/request/TaskCompleteRequest";
import {AssessmentKnowledgeSummaryModel} from "~~/package/mapper/assessment/model/AssessmentKnowledgeSummaryModel";
import {TaskModel} from "~~/package/mapper/learning/model/TaskModel";
import type AssessmentResponse from "~~/package/apis/assessment/response/AssessmentResponse";
import type ProvisionStatusResponse from "~~/package/apis/assessment/response/ProvisionStatusResponse";
import {ProvisionStatusModel} from "~~/package/mapper/assessment/model/ProvisionStatusModel";
import type CustomResponse from "~~/package/types/ResponseType";

export default class AssessmentMapper {

    protected assessmentApi: AssessmentApi;
    constructor(context: ApplicationContextInterface) {
        this.assessmentApi =  context.getService<AssessmentApi>(DependencyInjectId.AssessmentApi)
    }

    public async getAssessmentResultList(trackId: number, lang: string): Promise<AssessmentResultListModel> {
        const assessmentResponse: CustomResponse<AssessmentResultListModel> = (await this.assessmentApi.getAssessmentResultList(trackId, lang)).data;
        return AssessmentHelper.mappingAssessmentResultList(assessmentResponse.data);
    }

    public async getAssessmentResultDetail(assessmentId: number, lang: string): Promise<AssessmentResultDetailModel> {
        const assessmentResponse: CustomResponse<AssessmentResultDetailModel> = (await this.assessmentApi.getAssessmentResultDetail(assessmentId, lang)).data;
        return AssessmentHelper.mappingAssessmentResultDetail(assessmentResponse.data);
    }

    public async getAssessmentAvailableCount(trackId: number): Promise<AssessmentAvailableCountModel> {
        const assessmentResponse: CustomResponse<AssessmentAvailableCountModel> = (await this.assessmentApi.getAssessmentAvailableCount(trackId)).data;
        return AssessmentHelper.mappingAssessmentAvailableCountData(assessmentResponse.data);
    }

    public async getAssessmentList(trackId: number, lang: string): Promise<TaskModel[]> {
        const assessmentResponse: CustomResponse<AssessmentResponse[]> = (await this.assessmentApi.getAssessmentList(trackId, lang)).data;
        return assessmentResponse.data.map((assessment) => AssessmentHelper.mappingAssessmentListData(assessment));
    }

    public async setAssessmentAnswerList(trackId: number, size: number, request: TaskCompleteRequest[]): Promise<boolean> {
        return (await this.assessmentApi.setAssessmentAnswerList(trackId, size, request)).data.data;
    }

    public async getAssessmentKnowledgeSummaryList(trackId: number, assessmentId: number, lang: string): Promise<AssessmentKnowledgeSummaryModel[]> {
        const assessmentResponse: CustomResponse<AssessmentKnowledgeSummaryModel[]> = (await this.assessmentApi.getAssessmentKnowledgeSummaryList(trackId, assessmentId, lang)).data;
        return assessmentResponse.data.map((assessment) => AssessmentHelper.mappingAssessmentKnowledgeSummaryListData(assessment));
    }

    public async getProvisionStatus(assessmentId: number): Promise<ProvisionStatusModel> {
        const provisionStatusResponse: CustomResponse<ProvisionStatusResponse> = (await this.assessmentApi.getProvisionStatus(assessmentId)).data;
        return AssessmentHelper.mappingProvisionStatus(provisionStatusResponse.data);
    }
}
